import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

const ROLE_LABELS = {
  admin: "Super Admin",
  kitchen: "Kitchen / Operations",
  finance: "Finance",
  client: "Client User",
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out
  const [loading, setLoading] = useState(true);
  const [modules, setModules] = useState(null); // null = staff/unrestricted; array = client allowed modules

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    if (user && user.role === "client") {
      api.get("/me/context").then((r) => setModules(r.data.allowed_modules || [])).catch(() => setModules([]));
    } else {
      setModules(null);
    }
  }, [user]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, modules, login, logout, refresh, roleLabel: user ? ROLE_LABELS[user.role] : "" }}>
      {children}
    </AuthContext.Provider>
  );
}

export { ROLE_LABELS };
